module.exports = __webpack_public_path__ + "img/A11.ad3667de.svg";